import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Modal } from "react-bootstrap";
import Logo from "../../../components/logo/Logo";
import SocialLogin from "../../../components/socialLogin/SocialLogin";
import Input from "../../../components/common/Input";
import Button from "../../../components/common/Button";
import Form from "../../../components/common/Form";
import { handleShowPassword, validateEmail } from "../../../utils";
import { SERVER_URL } from "../../../config";
import "./index.scss";
import { SET_LOGIN_USER_SUCCESS } from "../../../store/actions/loginActions";
import { OnLogin, OnSocialLogin } from "./queries";
import skillOffer from "../../../svg/skill-offer.svg";
import active_email from "../../../svg/active-email.svg";
import verifiedIcon from "../../../svg/verifiedCheck.svg";
import active_lock from "../../../svg/active-lock.svg";
import disable_email from "../../../svg/disable-email.svg";
import disable_lock from "../../../svg/disable-lock.svg";
import active_eye from "../../../svg/active-eye.svg";
import disable_eye from "../../../svg/disable-eye.svg";
import Divider from "../../../components/common/Divider";
import FormModal from "../../../components/Modal/formModal";
import { OnForgotPassword } from '../forgotpassword/queries'
import { OnResendOtp, VerifyVendorEmail } from "../verifyEmail/queries";
import VerifyOtp from "../verifyotp";
import LeftBase from "../../../components/common/LeftBase";
import Checkbox from "../../../components/common/Checkbox";
import SuccessModal from "../../../components/Modal/successModal";


export default function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [mobileNumber, setMobileNumber] = useState({})
  const [errorMsg, setErrorMsg] = useState('')
  const [otp, setOtp] = useState();
  const [mobileOtp, setMobileotp] = useState()
  const [userId, setUserId] = useState()
  const [VerifyPopupOpen, setVerifyPopupOpen] = useState(false);
  const [VerifyMobilePopupOpen, setVerifyMobilePopupOpen] = useState(false);
  const [userData, setUserData] = useState(null);

  const [loginCredentials, setLoginCredentials] = useState({});
  const [disabled, setDisabled] = useState(true);
  const [forgotDisabled, setForgotDisabled] = useState(true)
  const [forgotPasswordOpen, setForgotPasswordOpen] = useState(false);
  const [email, setEmail] = useState();
  const [registrationModal, setRegistrationModal] = useState({show: false, published: false});
  const [error, setError] = useState({ apiError: '' })
  const [showResetSend, setResetSend] = useState(false);
  const [checkboxes , setCheckboxes] = useState({
    loginInfoChecked : false
  })
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const socialSucessHandler = (success) => {
    setErrorMsg('');
    if(!success?.data?.isSetupProfile) {
      localStorage.setItem("vendorToken", success.data?.token);
      dispatch({
        type: SET_LOGIN_USER_SUCCESS,
        payload: success?.data,
      });
      navigate("/dashboard");
      return null;
    } else {
      setRegistrationModal({show: true, published: success?.data?.isSetupProfile ? true : false});
    }
  };
  //new code 
  const EmailsucessHandler = (sucess) => {
    setVerifyPopupOpen(false)
    setVerifyMobilePopupOpen(true)
    setErrorMsg('')
  }
  const MobilesucessHandler = (sucess) => {
    setMobileotp()
    setOtp()
    setVerifyMobilePopupOpen(false)
    setErrorMsg('')
    localStorage.setItem("vendorToken", userData?.token);
    dispatch({
      type: SET_LOGIN_USER_SUCCESS,
      payload: userData,
    });
    // window.location.reload()
  }

  const handleVerifyEmailSubmit = (e) => {
    e.preventDefault()
    const headers = {
      otp: otp,
      userId: userId
    }
    verifyEmail(headers)
  }

  const handleVerifyMobileSubmit = (e) => {
    e.preventDefault()
    const headers = {
      otpForMobileVerification: mobileOtp,
      userId: userId
    }
    verifyMobile(headers)
  }

  const resendOtpSucess = (sucess) => {
    if (sucess?.data?.otpformobileverification) {
    //   setMobileotp(sucess?.data?.otpformobileverification)
      setMobileotp("");
    }
  }
  const handleRensedOtp = (e, type) => {
    e.preventDefault()
    if (type === 'email') {
      let param = {
        email: email
      }
      resedOtp(param)
    }
    else {

      let param = {
        phoneNumber: mobileNumber
      }
      resedOtp(param)
    }
  }


  //new code 
  const { mutate: socialLogin } = OnSocialLogin(socialSucessHandler);

  const handleSocialLogin = (result) => {
    const data = result?.user;
    const apiBody = {
      fullName: data?.displayName,
      email: (result?.providerId === "twitter.com") ? result?.['_tokenResponse']?.email : data?.email,
      rawId: data?.uid,
      isSocialLogin: true,
    };
    socialLogin(apiBody);
  };

  const sucessHandler = (auth) => {
    const { emailVerified, mobileVerified, email, phoneNumber, _id } = auth?.data?.data
    setUserData(auth?.data)
    setMobileNumber(phoneNumber)
    setEmail(email)
    setUserId(_id)
    // setMobileotp(auth.data?.otpForMobile)
    if (emailVerified && mobileVerified) {
      localStorage.setItem("vendorToken", auth.data?.token);
      dispatch({
        type: SET_LOGIN_USER_SUCCESS,
        payload: auth?.data,
      });
    }
    else if (!emailVerified) {
      setVerifyPopupOpen(true);
    }

    else if (!mobileVerified) {
      setVerifyMobilePopupOpen(true)
    }
  };

  const { mutate: resedOtp } = OnResendOtp(resendOtpSucess, setErrorMsg)
  const { mutate: verifyEmail } = VerifyVendorEmail(EmailsucessHandler, setErrorMsg);
  const { mutate: verifyMobile } = VerifyVendorEmail(MobilesucessHandler, setErrorMsg);

  const { mutate: login } = OnLogin(sucessHandler, error, setError);
  const handleSubmit = async (e) => {
    e.preventDefault();
    login(loginCredentials);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoginCredentials({ ...loginCredentials, [name]: value });
  };

  const openForgotPassword = () => {

    setForgotPasswordOpen(true)
  }
  useEffect(() => {
    setForgotDisabled(!validateEmail(email));
  }, [email]);

  const sucessHandlerForgotPassword = (forgotSucess) => {
    return setForgotPasswordOpen(false)
  };

  const handleSubmitForgotPassword = (e) => {
    const data = { email: email };
    forgotPassword(data);
    setEmail('')
    setResetSend(true);
  };
  const { mutate: forgotPassword } = OnForgotPassword(sucessHandlerForgotPassword, setErrorMsg);

  useEffect(() => {
    setDisabled(
      !(validateEmail(loginCredentials?.email) && loginCredentials?.password)
    );
  }, [loginCredentials]);
  const handleCloseForgotPassword = () => {
    setForgotPasswordOpen(false)
    setErrorMsg('')
    setEmail('')
  }

  const handleRedirect = (e) => {
    e.preventDefault();
    if(registrationModal.published) {
      window.location.href = SERVER_URL
    } else {
      navigate('/')
    }
  }

  const handleRedirectVideo = (e) => {
    e.preventDefault();
    window.scroll({ top: 0, behavior: "smooth" });
    window.navigation.navigate(SERVER_URL + "browse");
  }

  const handleClickCheckbox = (e, type) => {
    const { name, checked } = e.target;
    return setCheckboxes({ ...checkboxes, [name]: checked });
  };
  return (
    <>
      <div className="container-flex login-page">
        <div className="row h-100">
          <div className="col-lg-4 col-xl-4 d-none d-lg-block left-base position-relative left-base">
            <LeftBase />
          </div>
          <div className="col-lg-8 col-xl-8 col-md-12 col-sm-12 m-auto">
            <p className="welcome_title py-2 text-end top_link">
              Not a member?
              <Link to="/registration" className="ms-1 link">
                Register Now
              </Link>
            </p>
            <div className="frame w-75 m-auto">
              <Logo />
              <Form onSubmit={handleSubmit}>
                <h4 className="mt-40 mb-1">LOGIN</h4>
                <p className="sub_title">
                  Welcome back. Let us log you in.
                </p>
                <Input
                  name="email"
                  handleChange={handleChange}
                  type="email"
                  preIconClass={
                    loginCredentials?.email ? active_email : disable_email
                  }
                  labelClass={loginCredentials?.email ? "" : "hidden"}
                  label="Email ID"
                  placeholder="Email ID"
                  value={loginCredentials.email}
                  className={loginCredentials?.email ? "active-input form-control with_icon" : "grey-input form-control with_icon"}
                />
                <Input
                  name="password"
                  handleChange={handleChange}
                  type={!showPassword ? "password" : "text"}
                  labelClass={loginCredentials?.password ? "" : "hidden"}
                  preIconClass={loginCredentials?.password ? active_lock : disable_lock}
                  postIconClass={loginCredentials?.password ? active_eye : disable_eye}
                  value={loginCredentials.password}
                  label="Password"
                  placeholder="Password"
                  onIconClick={() =>
                    handleShowPassword(setShowPassword, showPassword)
                  }
                  className={loginCredentials?.password ? "active-input form-control with_icon" : "grey-input form-control with_icon"}
                />
                <div className="label-error">{error?.apiError}</div>
                <div className="mt-2 mb-4">
                  <Link to="#" onClick={() => openForgotPassword()} className="linkFont">Forgot Password?</Link>
                </div>
                <div className="mb-4">
                  <Button type="submit" title="CONTINUE" disabled={disabled} />
                </div>
                <div className="my-4">
                  <Divider />
                </div>
              </Form>
              <p><Link to="/mobilelogin" className="linkFont">Continue With Mobile Login</Link></p>
              <p className="loginwith_txt">You can also login with</p>
              <SocialLogin handleSocialLogin={handleSocialLogin} />
              <div className="col-pd position-relative">
                <label className="small pt-2 text-start styledCheck d-flex align-items-center mb-4" >
                  <Checkbox className="form-check-input info-check"
                  name="loginInfoChecked"
                  id={"loginInfoChecked"}
                   checked={checkboxes.loginInfoChecked} onRadioChange={handleClickCheckbox} />
                  <span>
                  <Link to="#" className="link">I'd like to get information on new projects and marketing activities</Link>
                  </span>
                  </label>
              </div>
              <small className="footer_note">
                Do not forget to add us to your <span className="f-600">Safe Senders List</span><br />We will NEVER post anything without your permission. Isn't this cool?
              </small>
            </div>
          </div>
        </div>
        <FormModal show={VerifyPopupOpen} informationText="Please enter the OTP sent to your Email ID" modalHeading='Verify Email ID'>
          <VerifyOtp errorMsg={errorMsg} handleRensedOtp={handleRensedOtp} otp={otp} setOtp={setOtp} handleSubmit={handleVerifyEmailSubmit} type='email' />
        </FormModal>
        <FormModal show={VerifyMobilePopupOpen} handleClose={()=> setVerifyMobilePopupOpen(false)} informationText={`Your email ID has been successfully verified <img src=${verifiedIcon} alt="email" class="mx-1 mb-1" /> <br />Please enter the OTP sent to your mobile number`} modalHeading='Verify Mobile Number'>
          <VerifyOtp
            errorMsg={errorMsg} handleRensedOtp={handleRensedOtp} otp={mobileOtp} setOtp={setMobileotp} handleSubmit={handleVerifyMobileSubmit} type='mobile' />
        </FormModal>
        <FormModal upperInformationText="Let us help you set it up right away" lowerInformationText="Enter your email ID below to receive a reset link
" show={forgotPasswordOpen} customClass={"custom_forgot_password"} modalHeading='Forgot Password' onSubmit={handleSubmitForgotPassword} submitButtonTitle='Submit' disabled={forgotDisabled} handleClose={() => handleCloseForgotPassword()}>
          <Input
            name="email"
            handleChange={(e) => {
              setEmail(e.target.value)
            }}
            labelClass={email ? "" : "hidden"}
            type="email"
            preIconClass={email ? active_email : disable_email}
            showLabel
            label="Email ID"
            placeholder="Email ID"
            value={email}
            className={email
                ? "form-control active-input with_icon "
                : "form-control grey-input with_icon "
            }
          />
          <div className="label-error">{errorMsg}</div>
        </FormModal>

        <SuccessModal
        modalHeading='Password Reset Link Sent'
          upperInformationText="A link has been sent to your registered email id. Please follow the instructions."
          show={showResetSend}
          submitButtonTitle={"Close"}
          onSubmit={(e) => setResetSend(false)}
        />
        
        <Modal show={registrationModal.show} className="success-modal re-register " centered>
            <Modal.Header className="justify-content-center">
                <Modal.Title className="reg-title">YOU ARE ALREADY REGISTERED</Modal.Title>
                <button
                  type="button"
                  className="btn-close"
                  onClick={(e) => setRegistrationModal({show: false, published: false})}
                  aria-label="Close"
                />
            </Modal.Header>
              <div className="text-center label" dangerouslySetInnerHTML={{ __html: "We will get in touch with you soon..." }}/>
              <div className="text-center label mt-3 f-700 color-black f-size-16" dangerouslySetInnerHTML={{ __html: "Till then, we welcome you to listen to" }}/>
            {/* <Modal.Body></Modal.Body> */}
            <Modal.Footer className="justify-content-center">
                <Button handleClick={(e) => handleRedirectVideo(e)} title="MESSAGE FROM THE FOUNDER" type='button' />
                <div className="text-center">
                  <a onClick={handleRedirect} href='/' className="link text-decoration-none f-700">{registrationModal.published ? "Home" : "Continue Building Your Profile"}</a>
              </div>
            </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}
